import { asyncLoad } from '@util'
const AsyncSerialManage = asyncLoad(() =>
  import('@components/LocalMerchant/SerialManage/List')
)
const AsyncSerialDetail = asyncLoad(() =>
  import('@components/LocalMerchant/SerialManage/Detail')
)

export default {
  path: 'serialManage',
  indexRoute: {
    component: AsyncSerialManage,
    title: '系列管理'
  },
  stat: '系列管理/首页',
  childRoutes: [
    {
      path: 'detail(/:id)',
      component: AsyncSerialDetail,
      stat: '系列管理/发布系列'
    }
  ]
}
